<form [formGroup]="chartDashboardForm">
  <iv-live-charts-layout-menu
    [layoutsList]="layouts$ | async"
    formControlName="layoutMenuControl"
  ></iv-live-charts-layout-menu>

  <iv-live-chart-selector
    [listChartTypes]="allChartTypes$ | async"
    formControlName="chartSelector"
  ></iv-live-chart-selector>

  <div class="help" [ivLiveHint]="locale.help" ivLiveHintPosition="top-right">
    <a target="_blank" href="https://www.ivolatility.com/doc/Charts_User_guide.pdf">
      <img src="../../../../iv-live/assets/img/screener-tooltip-icon.png" alt="help" />
    </a>
  </div>
</form>
